import { UserProfile } from '@/types';

const baseUrl =
	(import.meta.env.VITE_USER_API_BASE_URL as string | undefined) ||
	(import.meta.env.VITE_API_BASE_URL as string | undefined) ||
	'https://3aa5gc94rf.execute-api.ap-southeast-2.amazonaws.com/dev';

async function http<T>(path: string, options: RequestInit): Promise<T> {
	const res = await fetch(`${baseUrl}${path}`, {
		...options,
		headers: {
			'Content-Type': 'application/json',
			...(options.headers || {})
		}
	});
	if (!res.ok) {
		const contentType = res.headers.get('content-type') || '';
		try {
			if (contentType.includes('application/json')) {
				const data = (await res.json()) as any;
				const msg =
					(typeof data?.message === 'string' && data.message) ||
					(typeof data?.error === 'string' && data.error) ||
					JSON.stringify(data);
				throw new Error(msg || `Request failed: ${res.status}`);
			} else {
				const text = await res.text();
				throw new Error(text || `Request failed: ${res.status}`);
			}
		} catch (e: any) {
			throw new Error(e?.message || `Request failed: ${res.status}`);
		}
	}
	return (await res.json()) as T;
}

export type UpdateUserParams = {
	name?: string;
	email?: string;
	country?: string;
};

export const UserService = {
	get: (authHeader: Record<string, string>) =>
		http<{ item: UserProfile }>('/user', {
			method: 'GET',
			headers: authHeader
		}),

	update: (updates: UpdateUserParams, authHeader: Record<string, string>) =>
		http<{ item: UserProfile }>('/user', {
			method: 'PUT',
			body: JSON.stringify(updates),
			headers: authHeader
		})
};
